<template lang="pug">
  div
    b-button.pt-1.pl-1.pr-1.pb-0(variant="light" @click="showModal = true")
      font-awesome-icon.refresh-button(icon="redo")

    b-modal(v-model="showModal" title="Forzar Recarga" no-close-on-backdrop)
      .text-center
        font-awesome-icon.mb-4(icon="exclamation-triangle" size="4x" class="exclamation-icon")
      p.text-center.font-weight-bold.question
        | ¿Estás seguro de que quieres recargar los datos?
      p.text-center.mb-0
        | Este preoceso puede tardar algunos segundos.
      p.text-center.mb-0
        | Usar esta función con demasiada frecuencia puede ralentizar el
        | sistema para todos los usuarios.
      p.text-center.mb-0
        | Por favor, úsala solo cuando sea realmente necesario.
      template(#modal-footer='{ ok, cancel, hide }')
        .d-flex.justify-content-between.w-100
          b-button(variant='secondary' @click='showModal = false') Cancelar
          b-button(
            variant='primary'
            @click='refreshDashboard'
            :disabled="loading"
          ) Aceptar
            b-spinner(v-if="loading" small)
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      showModal: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('TechniciansStore', ['listTechnicians']),
    async refreshDashboard() {
      this.$emit('refreshDashboard')
      this.showModal = false
      this.listTechnicians({ forceReload: true })
      this.$bvToast.toast('Recarga de datos exitosa', {
        title: 'Recarga de datos',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
        appendToast: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.exclamation-icon {
  color: #1D4ED8;
}
.question {
  font-size: 18px;
}
.refresh-button {
  border-radius: 50%;
  background: #1D4ED8;
  color: #fff;
  padding: 6px;
}
</style>
